import styled from 'styled-components';

import { SelectIdField, NumberField, PhoneField, TextField } from '~fields';

import { useOrganizationOptions, useUserOrganizationAsDefault } from '~hooks';

const TagsForm = props => {
  const {
    formId,
    formik: { setFieldValue, values },
  } = props;

  const organizationOptions = useOrganizationOptions({ formId });
  useUserOrganizationAsDefault({
    organizations: organizationOptions,
    change: value => setFieldValue('organization', value),
  });

  return (
    <Container>
      <SelectIdField name="accessControlSystemSelect" required />
      {values.accessControlSystemSelect === 'Muu järjestelmä' && (
        <TextField name="accessControlSystem" required />
      )}

      <NumberField name="accessTagAmount" required />
      <SelectIdField
        name="organization"
        options={organizationOptions}
        required
      />
      <PhoneField name="ordererPhone" required />
      <TextField name="ordererAddress" required />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);

  & > * {
    margin-bottom: 24px;
  }
`;

export default TagsForm;
